import React from 'react'
import hoistNonReactStatics from 'hoist-non-react-statics'
import UserSession from '../components/auth/UserSession'
import LandingLayout from '../components/layouts/Landing/Index'
import { Loading, FlexContainer } from '../components/common';


const withUserSession = (WrappedComponent, togglableVariables, defaultValues) => {
    class UserSessionWrapper extends React.Component {
        constructor(props){
            super(props);

            this.state = {
                reload : false
            }
        }

        render () {
            return (
                <UserSession>
                    {({ loading, ...userSession }) => {
                        return (
                            <LandingLayout>
                                <FlexContainer grow={1} align='center' justify='center'>
                                    <Loading loading={loading}>
                                        <WrappedComponent {...this.props} session={userSession} />
                                    </Loading>
                                </FlexContainer>
                            </LandingLayout>
                        );
                    }}
                </UserSession>
            )
        }
    }

    return hoistNonReactStatics(UserSessionWrapper, WrappedComponent)
}

export default withUserSession
